import Card from "../../components/Global/Card";

import React from "react";
import { RiDashboardLine } from "react-icons/ri";
import { LuFileSpreadsheet } from "react-icons/lu";
import { FaUsers } from "react-icons/fa";
import BoxAction from "../../components/Global/BoxAction";

const Home = () => {
  return (
    <div className="flex flex-col w-full gap-4">
      <div className="flex gap-4">
        <BoxAction
          color="#3b82f6" // Azul
          title="Clientes Atendidos"
          titleColor="white"
          value="150"
          icon={<FaUsers style={{ color: "black", opacity: 0.3, fontSize: "100px", marginRight: "25px" }} />}
          width="220px"
        />
        <BoxAction
          color="#10b981" // Verde
          title="Pedidos de Orçamentos"
          titleColor="white"
          value="75"
          icon={<LuFileSpreadsheet style={{ color: "black", opacity: 0.3, fontSize: "100px" }} />}
          width="220px"
        />
      </div>
    </div>
  );
};

export default Home;
